// removed by extract-text-webpack-plugin
module.exports = {"preziCard":"PreziCard__preziCard___20-ha","reuseContainer":"PreziCard__reuseContainer___3nea9","reuseIcon":"PreziCard__reuseIcon___6OGlv","textTruncate":"PreziCard__textTruncate___2JMNx","thumbnailInfo":"PreziCard__thumbnailInfo___11MFW","preziThumbnail":"PreziCard__preziThumbnail___1TPRm","preziImage":"PreziCard__preziImage___3JLGL"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/css/PreziCard.less
// module id = 140
// module chunks = 1